import React from "react";
import { useFormContext } from "react-hook-form";

import { type CreateGamificationFormData } from "../../../validations/gamification.validation";
import type { BannerState } from "../../../hooks/use-banner-state";
import { BannersCard } from "../BannersCard";
import { RegulationsCard } from "../RegulationsCard";

type StepFilesProps = BannerState;

export const StepFiles: React.FC<StepFilesProps> = ({ cover, alternative }) => {
  const form = useFormContext<CreateGamificationFormData>();

  return (
    <>
      <BannersCard
        errors={form.formState.errors}
        cover={cover}
        alternative={alternative}
        campaignType={form.watch("campaignType")}
      />
      <RegulationsCard
        setValue={form.setValue}
        errors={form.formState.errors}
      />
    </>
  );
};
